import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { customersAPI, subscriptionsAPI, appsAPI, contactAPI, ticketsAPI } from '../../services/api'
import ChangelogCard from '../../components/common/ChangelogCard'

import { logger } from '@/utils/logger'

export default function AdminDashboard() {
  const [stats, setStats] = useState({
    totalCustomers: 0,
    activeSubscriptions: 0,
    totalApps: 0,
    newMessages: 0,
    openTickets: 0,
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadStats()
  }, [])

  const loadStats = async () => {
    try {
      const [customersRes, subscriptionsRes, appsRes, messagesRes, ticketsRes] = await Promise.all([
        customersAPI.getAll(),
        subscriptionsAPI.getAllAdmin(),
        appsAPI.getAll(),
        contactAPI.getAll(),
        ticketsAPI.getAllAdmin(),
      ])

      const activeSubscriptions = subscriptionsRes.data.filter(
        (s) => s.status === 'ACTIVE' || s.status === 'TRIAL'
      ).length

      const newMessages = messagesRes.data.filter((m) => !m.is_read).length
      const openTickets = ticketsRes.data.filter(
        (t) => t.status === 'open' || t.status === 'in_progress'
      ).length

      setStats({
        totalCustomers: customersRes.data.length,
        activeSubscriptions,
        totalApps: appsRes.data.length,
        newMessages,
        openTickets,
      })
    } catch (error) {
      logger.error('Error loading stats:', error)
    } finally {
      setLoading(false)
    }
  }

  const statCards = [
    { label: 'Kunden gesamt', value: stats.totalCustomers },
    { label: 'Aktive Abos', value: stats.activeSubscriptions, accent: true },
    { label: 'Apps', value: stats.totalApps },
    { label: 'Neue Kontaktanfragen', value: stats.newMessages },
    { label: 'Offene Tickets', value: stats.openTickets },
  ]

  const adminSections = [
    { title: 'Kunden verwalten', path: '/admin/customers', description: 'Kundenverwaltung und -übersicht' },
    { title: 'Apps verwalten', path: '/admin/apps', description: 'App-Verwaltung und -konfiguration' },
    { title: 'Abonnements', path: '/admin/subscriptions', description: 'Abo-Verwaltung' },
    { title: 'Support', path: '/admin/support', description: 'Ticket-Verwaltung' },
    { title: 'CMS verwalten', path: '/admin/cms', description: 'Seiten, Menü und Footer bearbeiten' },
    { title: 'Kontaktanfragen', path: '/admin/messages', description: 'Kontaktformular-Nachrichten' },
    { title: 'Systemeinstellungen', path: '/admin/settings', description: 'E-Mail-Versand und weitere Einstellungen' },
  ]

  return (
    <div>
      <h1 style={{ fontSize: 26, margin: '0 0 6px' }}>Willkommen im Admin-Bereich</h1>
      <p className="wc-muted" style={{ margin: '0 0 32px', fontSize: 14 }}>
        Stand: {new Date().toLocaleDateString('de-DE')}
      </p>

      {/* Stat cards */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
          gap: 16,
          marginBottom: 32,
        }}
      >
        {statCards.map((card) => (
          <div key={card.label} className="wc-card wc-elev-sm" style={{ gap: 6 }}>
            <span className="wc-muted" style={{ fontSize: 13 }}>{card.label}</span>
            <span style={{ fontSize: 28, color: card.accent ? 'var(--wc-accent-300)' : undefined }}>
              {loading ? '–' : card.value}
            </span>
          </div>
        ))}
      </div>

      {/* Sections */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: 16,
          marginBottom: 32,
        }}
      >
        {adminSections.map((section) => (
          <Link
            key={section.path}
            to={section.path}
            className="wc-card wc-elev-sm wc-card-hover"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <h3 className="wc-card-title" style={{ margin: 0 }}>{section.title}</h3>
            <p className="wc-card-body" style={{ margin: 0 }}>{section.description}</p>
          </Link>
        ))}
      </div>

      <ChangelogCard />
    </div>
  )
}
